import { render, staticRenderFns } from "./FPTextareaNote.vue?vue&type=template&id=52a79e3a"
import script from "./FPTextareaNote.vue?vue&type=script&lang=js"
export * from "./FPTextareaNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports